require('./brokerTransferPensionPlansInternalStep2.scss');

const PropTypes = require('prop-types');
//@commons
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

// @Utilities

// @vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @Components
const { LoadingSection } = require('commonsComponents/loadingSection');
const DropdownPlans = require('components/broker/brokerDropdownPlans/dropdownPlans');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { BrokerAdvancedSearchExplore } = require('components/broker/brokerAdvancedSearch/brokerAdvancedSearchExplore/brokerAdvancedSearchExplore');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const BrokerTransferPensionPlansSummary = require('components/commons/broker/brokerTransferPensionPlansDataSummary/brokerTransferPensionPlansDataSummary');

//@utilities
const { getCurrentAccounts } = require('utilities/currentAccountsHelper.js');



// @Constants
const {
    BROKER_TRANSFER_PENSION_PLANS_DEST_EXIST_OPTION,
    BROKER_TRANSFER_PENSION_PLANS_DEST_NEW_OPTION
} = require('constants/index');


class BrokerTransferPensionPlansInternalStep2 extends React.Component {

    constructor(props){
        super(props); 
        this.state = {
            filterSettingsOpen: false
        };
        this.handleProduct = this.handleProduct.bind(this);
        this.buildAccountDropdown = this.buildAccountDropdown.bind(this);
        this.buildPlansDropDown = this.buildPlansDropDown.bind(this);
        this.buildAdvancedSearch = this.buildAdvancedSearch.bind(this);
        this.buildRadioButtonBlock = this.buildRadioButtonBlock.bind(this);
        this.buildPlanData = this.buildPlanData.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
    }

    componentDidMount() {
        const { handleFilterDestinationPlans, immPlans } = this.props;
        handleFilterDestinationPlans(immPlans);
    }

    buildPlansDropDown() {
        const {
            immStep, 
            onSelectPlan
        } = this.props;
        const destinationPlan = immStep.getIn(['destinationPlanData', 'internalId']);
        const immPlans = immStep.get('availablePlansInWallet');
        let error = !immStep.get('validDestinationPlan');
        let enabled = !immStep.get('isFetching');
        let errorMsg = formatText('brokerTraspassBetweenMyPlans-step1ErrorNoPlanSelected');
    
        return (
            <div className="broker-transfer-pension-plans-internal-step2__dropdown">
                <DropdownPlans
                    id="broker-origin-plans"
                    immPlans={immPlans}
                    isOriginPlan={false}
                    currentPlanId={destinationPlan}
                    onPlanChange={onSelectPlan}
                    error={error}
                    errorMsg={errorMsg}
                    enabled={enabled}
                />  
            </div>
        )
    }

    buildAccountDropdown() {

        const { immAccounts , immStep, onAccountChange } = this.props;
        const accountsById = immAccounts.get('byId');
        const accountsIndexes = getCurrentAccounts(immAccounts.get('byOrder').toJS(), accountsById);
        const error = !immStep.get('validAccount');
        const accountId = immStep.getIn(['destinationPlanData', 'associatedAccount' , 'productId']);
        
        return (
            <div className="broker-transfer-pension-plans-internal-step2__dropdown-block">
                <div className="broker-transfer-pension-plans-internal-step2__info">
                    <FormattedText value="brokerTraspassBetweenMyPlans-associateAccount"/>
                </div>
                <div className="broker-transfer-pension-plans-internal-step2__dropdown">
                    <DropdownAccounts
                        id="drd_PassStep1_Origin"
                        immAccounts={accountsById}
                        accountsIndexes={accountsIndexes}
                        onAccountChange={onAccountChange}
                        showAvailableBalance={true}
                        error={error}
                        currentAccountId={accountId}
                    />
                </div>
                <div className="broker-transfer-pension-plans-internal-step2__foot">
                    <FormattedText value="brokerTraspassBetweenMyPlans-associateAccountFoot" />
                </div>
                <hr/>
            </div>
        );
    }

    handleProduct(option) {
        this.props.handlePlanSelectFromSearch(option);
        this.setState({
            filterSettingsOpen: false
        })
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    buildAdvancedSearch(){
        const { immStep, immStep1, handlePlanSelectFromSearch } = this.props;
        const planSelected = immStep.get('planSelectedFromSearcher');
        const plansInWallet = immStep.get('availablePlansInWallet');
        const originPlanData = immStep1.get('originPlanData');
        let plansToFilter = plansInWallet.map(plan => plan.getIn(['comercialData','DGSCode']));
        plansToFilter = plansToFilter.push(originPlanData.getIn(['comercialData','DGSCode']));

        return (
            <div className="external-transfer-fund-step2">
                <div className="broker-transfer-pension-plans-internal-step2__input-search">
                    <BrokerAdvancedSearchExplore
                        plansToFilter={plansToFilter}
                        selectedNewPlan={planSelected}
                        fromPlansTransfer={true}
                        onHandleProductSelect={handlePlanSelectFromSearch}
                    >
                    </BrokerAdvancedSearchExplore>
                </div>
            </div>
        )
    }

    buildRadioButtonBlock() {
        const {
            immStep,
            onChangeDestinationOption
        } = this.props;
        const target = immStep.get('destinationTarget');
        return (
            <RadioButtonGroup
                idPrefix="brokerTraspassBetweenMyPlans"
                name="destination-target"
                onChange={onChangeDestinationOption}
                selectedValue={target} 
                className="broker-transfer-pension-plans-internal-step2__configuration-options-group"
                isHorizontal={true}
            >
                <RadioButton
                    disabled={immStep.get('destinationInWalletDisabled') || immStep.get('isFetching')}
                    label={formatText('brokerTraspassBetweenMyPlans-step2PlanInWallet')}
                    value={BROKER_TRANSFER_PENSION_PLANS_DEST_EXIST_OPTION}
                />
                <RadioButton
                    disabled={immStep.get('isFetching')}
                    label={formatText('brokerTraspassBetweenMyPlans-step2HireNewPlan')}
                    value={BROKER_TRANSFER_PENSION_PLANS_DEST_NEW_OPTION}
                />
            </RadioButtonGroup>
        );
    }

    buildPlanData() {
        const { immStep } = this.props;
        const destinationPlan = immStep.get('destinationPlanData');
        const planSelected = immStep.get('planSelected');
        const options = {
            planInWallet: immStep.get('planFromWallet')
        }

        let content;

        if(immStep.get('isFetching')) {
            content = (
                <LoadingSection />
            );
        } else if(planSelected){// && (immStep.get('success') || immStep.get('notFound'))) {
            content = (
                <div className="broker-transfer-pension-plans-internal-step2__summary">
                    <BrokerTransferPensionPlansSummary
                        destinationPlanData={destinationPlan} 
                        options={options}/>
                </div> 
                )
        }
        
        return content;
    }

    render(){
        const { immStep } = this.props;
        let boxTitle;
        let guideText = (
            <div className="broker-transfer-pension-plans-internal-step2__info">
                <FormattedText value="brokerTraspassBetweenMyPlans-step2SelectPlan" />
            </div>
            );
        if (immStep.get('destinationTarget') === BROKER_TRANSFER_PENSION_PLANS_DEST_NEW_OPTION) {
            boxTitle = (
                <OKBoxTitle
                    className="broker-transfer-pension-plans-internal-step2__title"
                    value={formatText('brokerTraspassBetweenMyPlans-step2AlternativeTitle')} />
                )
        
            return (
                <div className="broker-transfer-pension-plans-internal-step2">
                    {boxTitle}
                    <div className="broker-transfer-pension-plans-internal-step2__subtitle">
                        <FormattedText value="brokerTraspassBetweenMyPlans-step2Title" />
                    </div>
                    <div className="broker-transfer-pension-plans-internal-step2__radio-button-block">
                        {this.buildRadioButtonBlock()}
                    </div>
                    <div >
                        {this.buildAccountDropdown()}
                    </div>
                    {guideText}
                    {this.buildAdvancedSearch()}
                </div>
            )
        }
        else {
            boxTitle = (
                <OKBoxTitle
                    className="broker-transfer-pension-plans-internal-step2__title"
                    value={formatText('brokerTraspassBetweenMyPlans-step2Title')} />
                )
            return (
                <div className="broker-transfer-pension-plans-internal-step2">
                    {boxTitle}
                    {guideText}
                    <div className="broker-transfer-pension-plans-internal-step2__subtitle">
                        <FormattedText value="brokerTraspassBetweenMyPlans-step2Title" />
                    </div>
                    <div className="broker-transfer-pension-plans-internal-step2__radio-button-block">
                        {this.buildRadioButtonBlock()}
                    </div>
                    <div className="broker-transfer-pension-plans-internal-step2__info">
                        {this.buildPlansDropDown()}
                    </div>
                    {this.buildPlanData()}
                </div>
            )
        }
    }
}

BrokerTransferPensionPlansInternalStep2.propTypes = {
    handleFilterDestinationPlans: PropTypes.func.isRequired,
    handlePlanSelectFromSearch: PropTypes.func.isRequired,
    immPlans: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    immStep1: PropTypes.object.isRequired,
    onSelectPlan: PropTypes.func.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    onChangeDestinationOption: PropTypes.func.isRequired
}

module.exports = BrokerTransferPensionPlansInternalStep2;
